export default __webpack_public_path__ + "static/media/public-safety-replay-full.en.0adfd98f.vtt";